import { SubmissionError } from 'redux-form';

import { guestFields, companyFields } from './enums/Guest';
import { guestDetailFields, isVisaRequiredForCountry, isAtLeast15 } from './enums/GuestDetails';
import { SANDAMIANO_HOTEL_ID } from './utils';
import { isWithoutAccommodation } from './apiHelpers';

/**
 * Funkce rozhoduje o tom, zda je povolené tlačítko Pokračovat v navbaru.
 *
 * @param formValues
 * @param step
 * @param isPaymentGatewayEnabled
 * @param app
 * @returns {boolean}
 */
export function isContinueEnabled(formValues, step, isPaymentGatewayEnabled = false, app = {}) { // TODO rozložit parametr app?

	const isAtLeastOneRoomSelectedAndAtLeastOnePersonPerSelectedRoom = () => {
		let isAtLeastOneRoomSelected = false;

		for (let rooms of Object.values(formValues.rooms)) {
			if (!rooms || !rooms.length) continue;

			for (let room of rooms) {
				let isEmpty = true;
				for (let noOfGuests of Object.values(room.guestTypes)) {
					if (noOfGuests > 0) {
						isEmpty = false;
						isAtLeastOneRoomSelected = true;
						break;
					}
				}
				if (isEmpty) {
					return false;
				}
			}
		}

		return isAtLeastOneRoomSelected;
	};

	if (step === 1) {
		for (let rooms of Object.values(formValues.rooms)) {
			if (rooms.length) {
				return true;
			}
		}
		return false;
	}

	if (step === 2) {
		return isAtLeastOneRoomSelectedAndAtLeastOnePersonPerSelectedRoom();
	}

	if (step === 3) {
		return true;
	}

	if (step === 4) {
		return !validateStep4FormValues(formValues, false, app);
	}

	if (step === 5) {
		return isAtLeastOneRoomSelectedAndAtLeastOnePersonPerSelectedRoom() &&
			(!isPaymentGatewayEnabled || formValues.paymentMethod);

	}

	return false;
}

export function validateStep4FormValues(formValues, throwError = true, app = {}) // TODO rozložit parametr app?
{
	const errors = {};

	const withoutAccommodation = isWithoutAccommodation(formValues);

	// sandamiano: u rezervace bez ubytování se vyplňuje jméno, příjmení, email a telefon
	const visibleGuestFields = app.hotelId === SANDAMIANO_HOTEL_ID
		? guestFields.filter(field => ['email', 'phone'].concat(withoutAccommodation ? ['firstName', 'lastName'] : []).includes(field.name))
		: guestFields;

	for (let field of visibleGuestFields) {
		if (field.required !== undefined && field.required === false) continue;

		if (!formValues[field.name] || !formValues[field.name].length) {
			errors[field.name] = [[field.label], ' ', ['validators.required']];

		} else {

			if (field.name === 'email' && !isEmailValid(formValues[field.name])) {
				errors[field.name] = 'validators.email';

			} else if (field.name === 'phone' && !isPhoneValid(formValues[field.name])) {
				errors[field.name] = 'validators.phone';
			}
		}
	}

	if (app.hotelId === SANDAMIANO_HOTEL_ID && !withoutAccommodation) {
		// pro tento hotel v podstatě přebíráme validaci z online check-in formuláře
		const requiredFields = app.requiredFields || [];
		const countries = app.countries || [];
		const guestDetailsErrors = [];

		for (let i = 0; i < (app.totalNoOfGuests || 0); i++) {
			const guest = (formValues.guestDetails || [])[i] || {};
			const guestErrors = {};

			for (let field of guestDetailFields) {
				if (requiredFields.includes(field.name)) continue;
				// podpis je povinný pouze u hostů od druhého dál, u prvního hosta nikdy
				if (field.name === 'signature' && i === 0) continue;

				if (!guest[field.name] || !guest[field.name].toString().length) {
					guestErrors[field.name] = [[field.label], ' ', ['validators.required']];
				}
			}

			if (requiredFields.includes('idcard_type_id')) {
				if (isAtLeast15(guest.birth_date) && (!guest.idcard_number || !guest.idcard_number.toString().length)) {
					guestErrors.idcard_number = [['GuestDetails.idcardNumber'], ' ', ['validators.required']];
				}

				if (isVisaRequiredForCountry(countries, guest.citizenship_id) && (!guest.visa || !guest.visa.toString().length)) {
					guestErrors.visa = [['GuestDetails.visa'], ' ', ['validators.required']];
				}
			}

			guestDetailsErrors.push(Object.keys(guestErrors).length ? guestErrors : undefined);
		}

		if (guestDetailsErrors.some(guestError => guestError !== undefined)) {
			errors.guestDetails = guestDetailsErrors;
		}
	}

	if (formValues.isCompany) {
		for (let field of companyFields) {
			if (field.required !== undefined && field.required === false) continue;

			if (!formValues[field.name] || (typeof formValues[field.name] === 'string' && !formValues[field.name].length)) {
				errors[field.name] = [[field.label], ' ', ['validators.required']];
			}
		}
	}

	if (throwError) {
		if (Object.keys(errors).length) {
			throw new SubmissionError(errors);
		}

	} else {
		return Object.keys(errors).length;
	}


}

export function isEmailValid(email) {
	const pattern = /^("([ !\x23-\x5B\x5D-\x7E]*|\\[ -~])+"|[-a-z0-9!#$%&'*+/=?^_`{|}~]+(\.[-a-z0-9!#$%&'*+/=?^_`{|}~]+)*)@([0-9a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,61}[0-9a-z\u00C0-\u02FF\u0370-\u1EFF])?\.)+[a-z\u00C0-\u02FF\u0370-\u1EFF][-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,17}[a-z\u00C0-\u02FF\u0370-\u1EFF]$/i;

	return !!email.match(pattern);
}

export function isPhoneValid(phone) {
	const pattern = /^\+\d+$/;

	// Mezery jsou v inputu povolené (např. +420 735 948 767), pro validaci je ignorujeme.
	return !!phone.replace(/\s/g, '').match(pattern);
}


// WEBPACK FOOTER //
// ./src/validators.js